import { useSpinner } from "@components/SpinnerContext";
import accomodationService from "@services/accomodation.service";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Page404 from '@pages/NotFoundPage';
import PageHeader from "@components/PageHeader";
import { SponsoredCardTranslation } from "@models/sponsored-card-translation-model";
import { t } from "i18next";
import CardSponsored from "@components/CardSponsored";
import InputComponent from "@components/InputComponent";

const SponsoredPage = () => {
  const { showSpinner, hideSpinner, loading } = useSpinner();
  const [isPageNotFound, setIsPageNotFound] = useState(false);
  const location = useLocation();
  const [cardSponsored, setCardSponsored] = useState<SponsoredCardTranslation[] | undefined>(undefined)
  const [filteredCardSponsored, setFilteredCardSponsored] = useState<SponsoredCardTranslation[] | undefined>(undefined)
  
  useEffect(() => {
    async function getSuggestionData(id: number, qrCodeId: string) {
      try {
        showSpinner()
        const response = await accomodationService.getSponsored()
        setCardSponsored(response)
        setFilteredCardSponsored(response)
      } catch (error) {
        setIsPageNotFound(true)
        console.log(error);
      } finally {
        hideSpinner()
      }
    }

    const parts = location.pathname.split("/").filter(Boolean);
    const qrCodeId = parts[0];
    const id = parts[parts.length - 2];

    getSuggestionData(parseInt(id), qrCodeId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="mx-3">
      <div className="sticky-top sticky-header border-bottom border-light">
        <PageHeader pageTitle={t("text.sponsored")} flagSearch={false} flag={false} />
        <div className="col-12">
          <InputComponent list={cardSponsored} setFilteredList={setFilteredCardSponsored} isAccomodation={false}/>
        </div>
      </div>
      {isPageNotFound ? (
        <Page404 />
      ) : (
        loading ? null : (
          <div className="container mt-4">
            <div className="row g-3">
              {filteredCardSponsored?.map((sponsored, i) => (
                <div className="col-12 col-md-6 col-lg-4 col-xl-3 d-flex align-items-stretch" key={sponsored.id}>
                  <CardSponsored sponsoredCardTranslation={sponsored} />
                </div>
              ))}
            </div>
          </div>
        )
      )}
    </div>

  );
};
export default SponsoredPage;